import 'core-js/es/map'
import 'core-js/es/set'
import 'raf/polyfill'
import 'react-app-polyfill/ie9'

import React from 'react'
import ReactDOM from 'react-dom'

import AppWithoutAuth from './AppWithoutAuth'

import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './styles/styles.scss'

import * as serviceWorker from './serviceWorker'

ReactDOM.render(<AppWithoutAuth />, document.getElementById('root'));

if (module.hot) {
  module.hot.accept('./AppWithoutAuth', () => {
	const AppWithoutAuth = require('./AppWithoutAuth').default
	render(AppWithoutAuth)
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

serviceWorker.unregister()
